import React from 'react'
import { Field, FieldProps } from 'formik'
import { FormFieldStatus, Input } from '@gousto-internal/citrus-react'

const AddressCountyInput = () => (
  <Field name="county">
    {({ field, meta }: FieldProps) => (
      <Input
        id="county"
        type="text"
        placeholder="County"
        autoComplete="address-level3"
        status={meta.error ? FormFieldStatus.Error : undefined}
        {...field}
      />
    )}
  </Field>
)

export { AddressCountyInput }
